import { BrowserRouter, Routes, Route } from "react-router-dom";

//pages
import { Home, SearchOS, PreOs, Success, PostsPage, PostByCep } from "@pages";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search-os" element={<SearchOS />} />
        <Route path="/create-pre-os" element={<PreOs />} />
        <Route path="/success/:item/:os" element={<Success />} />
        <Route path="/posts" element={<PostsPage />} />
        <Route path="/post-by-cep" element={<PostByCep />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
